<template>
  <v-container text-xs-center>
    <v-layout row wrap>
      <v-toolbar class="elevation-0" color="white" height="40"></v-toolbar>

      <v-container
        style="max-height: 30vh; max-width: 860px"
        class="scrollDesign"
      >
        <v-layout row wrap>
          <v-flex xs12 class="expandableContainer">
            <v-data-table
              :headers="headers"
              :items="cars"
              :loading="loading"
              hide-actions
              ref="table"
              item-key="id"
              no-data-text="No tiene carros"
              style="max-height: 18vh; overflow-y: scroll"
            >
              <template v-slot:headers="props">
                <th style="width: 200px; max-width: 200px; min-width: 200px">
                  Foto
                </th>
                <th style="width: 200px; max-width: 200px; min-width: 200px">
                  Modelo
                </th>
                <th style="width: 200px; max-width: 200px; min-width: 200px">
                  Placas
                </th>
                <th style="width: 200px; max-width: 200px; min-width: 200px">
                  Color
                </th>
              </template>
              <template v-slot:items="props">
                <td style="width: 200px; max-width: 200px; min-width: 200px">
                  <v-avatar
                    :tile="tile"
                    :size="avatarSize"
                    @click="selectCar(props.item)"
                  >
                    <v-avatar
                      :tile="tile"
                      :size="avatarSize"
                      color="grey lighten-4"
                      v-if="
                        props.item.imageStorage &&
                        props.item.imageStorage.miniObjUrl
                      "
                    >
                      <img
                        :src="props.item.imageStorage.miniObjUrl"
                        alt="avatar"
                      />
                    </v-avatar>
                    <v-icon v-else color="blue">directions_car</v-icon>
                  </v-avatar>
                </td>
                <td style="width: 200px; max-width: 200px; min-width: 200px">
                  {{ props.item.model }}
                </td>
                <td style="width: 200px; max-width: 200px; min-width: 200px">
                  {{ props.item.plates }}
                </td>
                <td style="width: 200px; max-width: 200px; min-width: 200px">
                  {{ props.item.color }}
                </td>
              </template>
            </v-data-table>
          </v-flex>
        </v-layout>
        <imagePreview
          v-model="toast.iPreview"
          :image="selected.image"
        ></imagePreview>
        <!--v-on:desition="desitionDelete"-->
        <loading v-model="working.wLoading" text="Trabajando"></loading>
        <success v-model="toast.success" text="Operación Exitosa"></success>
        <error v-model="toast.failed" text="Ups ocurrió un error"></error>
      </v-container>
    </v-layout>
  </v-container>
</template>
<script>
import error from '../../Dialogs/Error'
import imagePreview from '../../Dialogs/ImagePreview'
import loading from '../../Dialogs/Loading'
import success from '../../Dialogs/Success'
export default {
  components: {
    loading,
    success,
    error,
    imagePreview,
  },
  props: ['parentId'],
  data: () => ({
    headers: [
      {
        text: 'Foto',
        align: 'center',
        value: 'image',
        sortable: false,
      },

      {
        text: 'Modelo',
        align: 'center',
        value: 'model',
      },
      {
        text: 'Placas',
        align: 'center',
        value: 'plates',
      },
      {
        text: 'Color',
        align: 'center',
        value: 'color',
      },
    ],

    working: {
      wLoading: false,
    },
    cars: [],
    loading: true,
    avatarSize: '30px',

    buttonFab: {
      fab: false,
      hidden: false,
    },
    avatarSize: '30px',
    tile: false,
    selected: {
      image: '',
    },
    toast: {
      success: false,
      failed: false,
      iPreview: false,
    },
  }),
  created() {},
  mounted() {
    this.getCars()
  },
  methods: {
    getCars() {
      this.$store
        .dispatch('tutor/getParentCars', this.parentId)
        .then((response) => {
          this.loading = false
          this.cars = response.data.entity
          for (var c in this.cars) {
            this.cars[c].image = 'data:image/jpeg;base64,' + this.cars[c].image
          }
        })
        .catch((error) => {
          console.log(error)
          this.toast.failed = true
          this.loading = false
        })
    },
    selectCar(car) {
      this.selected.image = car.imageStorage.miniObjUrl
      this.toast.iPreview = true
    },
  },
}
</script>
<style scoped>
.no-padding {
  padding-left: 10%;
}
.position-no {
  position: absolute;
  top: 0px;
  right: 0px;
  z-index: -1;
}
td,
th {
  text-align: center !important;
  width: 295px;
  max-width: 295px;
  min-width: 295px;
}
::v-deep .v-datatable.v-table > tbody {
  max-height: initial !important;
  min-height: initial !important;
}
</style>
